import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import styled from "styled-components";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

import EmBreve from "./pages/EmBreve";

import Home from "./pages/Home";
import Noticias from "./pages/Noticias";

import Catalogo from "./pages/Catalogo";
import FichaTecnica from "./pages/FichaTecnica";
import Comparacao from "./pages/Comparacao";

import Ferramentas from "./pages/Ferramentas";
import CalculadoraCombustivel from "./pages/CalculadoraCombustivel";
import ComparadorCombustivel from "./pages/ComparadorCombustivel";

function Layout(){
  return (
    <PageContainer>
      <Header />

      <Content>
        <Outlet />
      </Content>

      <Footer />
    </PageContainer>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="em-breve" element={<EmBreve />} />
          <Route path="noticias" element={<Noticias />} />
          <Route path="ficha-tecnica" element={<FichaTecnica />} />
          <Route path="comparacao" element={<Comparacao />} />
          <Route path="ferramentas" element={<Ferramentas />} />
          <Route path="catalogo" element={<Catalogo />} />
          <Route path="calculadora-de-combustivel" element={<CalculadoraCombustivel />} />
          <Route path="comparador-de-combustivel" element={<ComparadorCombustivel />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Arial', sans-serif;
`;

const Content = styled.main`
  flex: 1;
`;